import GlobalTooltip from "../../../utility/tooltip/globalTooltip";
import { useCarouselFunctions } from "./useCarouselFunctions";
import { TooltipProps } from "@mui/material";

interface TouchTooltipProps {
    title: TooltipProps["title"];
    children: React.ReactElement<any, any>;
    placement?: TooltipProps["placement"];
    arrow?: boolean;
    key?: string;
    onOpen?: TooltipProps["onOpen"];
    onClose?: TooltipProps["onClose"];
}

const TouchTooltip = (props: TouchTooltipProps) => {

    const { title, children, placement, arrow = true, key, onOpen, onClose } = props;
    const { isMobileScreen } = useCarouselFunctions();

    return (
        <GlobalTooltip 
            key={key}
            title={title} 
            arrow={arrow}
            placement={placement ?? (isMobileScreen ? 'top-start' : 'top')} 
            enterTouchDelay={0} 
            leaveTouchDelay={4000}
            onOpen={onOpen}
            onClose={onClose}
        >
            {children}
        </GlobalTooltip>
    )
}

export default TouchTooltip;
